// frontend/src/pages/ReportsPage.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import ReportsPanel from '../components/ReportsPanel.tsx';
import { useUserPermissions } from '../hooks/useUserPermissions.ts';

const ReportsPage: React.FC = () => {
  const permissions = useUserPermissions();

  if (!permissions.isMaster) {
    return <Navigate to="/dashboard" replace />;
  }

  return <ReportsPanel />;
};

export default ReportsPage;
